module.exports = "<h1>\n  {{title}}\n</h1>\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/bdegroot/Projects/vgtropics-ph/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main